import React from "react";
import { Button } from "@chakra-ui/react";
import { getReportButtonProps } from "../Styles/reportToolbarStyles";

export function ReportActionButton({ children, variant = "secondary", ...props }) {
  return (
    <Button {...getReportButtonProps(variant)} {...props}>
      {children}
    </Button>
  );
}
